<template>
  <a-modal
    :title="$t('重置密码')"
    width="400px"
    :visible="visible"
    :maskClosable="false"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-form
        @submit="handleSubmit"
        :form="form"
      >
      <a-row>
        <a-col :span="24">
          <a-form-item
            :label="$t('手机或邮箱')"
            :required="true"
            :labelCol="{lg: {span: 6}}"
            :wrapperCol="{lg: {span: 16} }"
          >
            <a-input
              v-decorator="['mobile', {rules: [{ required: true, message: $t('邮箱或中国大陆手机号') }]}]"
              @change="changeMobile"
              :placeholder="$t('邮箱或中国大陆手机号')"
            />
          </a-form-item>
          <a-form-item
            :label="$t('验证码')"
            :required="true"
            :labelCol="{lg: {span: 6}}"
            :wrapperCol="{lg: {span: 16} }"
          >
            <a-input
              v-decorator="['code', {rules: [{ required: true, message: $t('请输入验证码') }]}]"
              style="width:50%;"
              :placeholder="$t('请输入验证码')"
            />
            <a-button style="width:48%;margin-left:2%;" @click="sendCode()">{{codeObj.bool ? codeObj.time + 's后再次发送' : $t('获取验证码')}}</a-button>
          </a-form-item>
          <a-form-item
            :label="$t('密码')"
            :required="true"
            :labelCol="{lg: {span: 6}}"
            :wrapperCol="{lg: {span: 16} }"
          >
            <a-input
              type="password"
              v-decorator="['password', {rules: [{ required: true, message: $t('请输入密码') },{validator: validateToNextPassword}]}]"
              :placeholder="$t('请输入密码')"
            />
          </a-form-item>
          <a-form-item
            :label="$t('再次输入')"
            :required="true"
            :labelCol="{lg: {span: 6}}"
            :wrapperCol="{lg: {span: 16} }"
          >
            <a-input
              type="password"
              v-decorator="['confirm', {rules: [{ required: true, message: $t('请输入确认密码') },{validator: compareToFirstPassword}]}]"
              :placeholder="$t('请输入确认密码')"
              @blur="handleConfirmBlur"
            />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>

</template>
<script>
import matchFun from '@comm/utils/matchFun'
export default {
  data () {
    return {
      visible: false,
      mobile: '',
      confirmDirty: false,
      smsId: null,
      codeObj: {
        time: 60,
        bool: false
      },
      matchFun,
      form: this.$form.createForm(this)
    }
  },
  methods: {
    showModal () {
      this.smsId = null
      this.codeObj = {
        time: 60,
        bool: false
      }
      this.mobile = ''
      this.visible = true
    },
    handleCancel () {
      this.visible = false
    },
    changeMobile (e) {
      this.mobile = e.target.value
    },
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log(values)
          let valData = {
            newPassword: values.password,
            smsCode: values.code,
            smsId: this.smsId,
            phone: values.mobile
          }
          this.$api.user.forgotPwd(valData).then(res => {
            if (res.status === 0) {
              this.$message.success('重置成功')
              this.handleCancel()
            } else {
              this.$message.error(res.msg)
            }
          }).catch(err => {
            console.log(err)
          })
        }
      })
    },
    handleConfirmBlur (e) {
      const value = e.target.value
      this.confirmDirty = this.confirmDirty || !!value
    },
    compareToFirstPassword (rule, value, callback) {
      const form = this.form
      if (value && value !== form.getFieldValue('password')) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('两次密码不一致，请检查!')
      } else {
        callback()
      }
    },
    validateToNextPassword (rule, value, callback) {
      const form = this.form
      if (value && this.confirmDirty) {
        form.validateFields(['confirm'], { force: true })
      }
      callback()
    },
    sendCode () {
      if (this.mobile === '') {
        this.$message.error('请输入邮箱或中国大陆手机号')
        return
      }
      if (!matchFun.phoneFun(this.mobile) && !matchFun.emailFun(this.mobile)) {
        this.$message.error('请输入正确的邮箱或中国大陆手机号')
        return
      }
      this.codeObj.bool = true
      let that = this
      const interval = window.setInterval(() => {
        if (that.codeObj.time-- <= 0) {
          that.codeObj.time = 60
          that.codeObj.bool = false
          window.clearInterval(interval)
        }
      }, 1000)
      const hide = that.$message.loading('验证码发送中..', 0)
      that.$api.user.forgotPwdSms({phone: that.mobile}).then(res => {
        setTimeout(hide, 1)
        if (res.status === 0) {
          that.smsId = res.data
          that.$message.success('验证码获取成功')
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {
        setTimeout(hide, 1)
        that.codeObj.time = 60
        that.codeObj.bool = false
        clearInterval(interval)
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/comm/components/modal/ResetPassword.vue